// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__wTwIA","logo__gray":"logo_logo__gray__xfAgD","logo__green":"logo_logo__green__iEV4y"};